import React from 'react'
import withLayout from '../../layout/withLayout'
import ContentBox from '../../layout/component/ContentBox'
import Row from '../../bootstrap/component/Row'
import Column from '../../bootstrap/component/Column'
import LabelInput from '../../form/component/LabelInput'
import Select from '../../form/component/Select'


const EmployeeSettings = ({ employee, sipGateDeviceList, setSipGateDeviceId, changeEmployee }) => {
    return (
        <ContentBox title="My Settings">
            <Row>
                <Column size={6}>
                    <LabelInput label="SipGate Device">
                        <Select
                            addEmpty={true}
                            object={employee}
                            name="sipGateDeviceId"
                            onChange={(name, value) => {
                                changeEmployee(name, value)
                                setSipGateDeviceId()
                            }}
                            valueList={sipGateDeviceList}
                            renderer={sipGateDevice => {
                                return sipGateDevice.alias
                            }}/>
                    </LabelInput>
                </Column>
            </Row>
        </ContentBox>
    )
}


export default withLayout(EmployeeSettings)



// WEBPACK FOOTER //
// ./src/modules/employee/component/EmployeeSettings.js